import React, { createContext } from "react";
import "./App.css";
import Start3 from "./Class 3/Start3";

function App() {
  return (
    <div>
      <Start3 />
    </div>
  );
}

export default App;
